/* eslint-disable @typescript-eslint/no-empty-function */
import { useCallback, useEffect, useRef, useState } from 'react'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import Container from '../../../../components/Container'
import api from '../../../../services/api'
import { useToast } from '../../../../hooks/toast'
import { useLoading } from '../../../../hooks/loading'
import { Alert } from '../../../../components/Alert'
import { nameActions } from '../domain/info'
import { apiDelete, apiDeleteSerieClass, apiList } from '../domain/api'
import { breadcrumbView } from '../domain/breadcrumb'
import Tabs from '../../../../components/Tabs'
import Tab from '../../../../components/Tabs/Tab'
import DataTable from '../../../../components/DataTable'

import {
  toolsViewCreate,
  toolsViewDelete,
  toolsViewUpdate,
  toolsViewList
} from '../domain/tools'
import { cnpjMask, currencyMask, phoneMask } from '../../../../utlis/mask'
import { headersMenuQueryApi, headersStudentQueryApi } from '../domain/headers'
import ViewInfoLabel from 'components/ViewInfoLabel'
import { LinkContainer, MenuTable, MenuTableRow } from 'pages/Menus/View/styles'
import Modal from 'components/Modal'
import { FormSerieClass } from '../components/FormSerieClass'
import { FormAbsencePeriod } from '../components/FormAbsencePeriod'
import FormAddFinancialMoviment from '../components/FormAddFinancialMoviment'
import moment from 'moment'
import {
  FaEnvelope,
  FaFileCode,
  FaFileInvoice,
  FaFilePdf
} from 'react-icons/fa'

const InstitutionView = (): JSX.Element => {
  const { id } = useParams<{ id: string }>()
  const history = useHistory()
  const location = useLocation()
  const [institution, setInstitution] = useState<IInstitutionData | null>(null)
  const { addToast } = useToast()
  const { disableLoading, activeLoading } = useLoading()
  const [alert, setIsActiveAlert] = useState<{
    isActive: boolean
    id: number
    name: string
  }>({
    id: 0,
    isActive: false,
    name: ''
  })
  const searchParams = useRef([{ institution_id: id }])
  const searchParametersAuditLog = useRef([
    { entity: 'Institution', entity_id: id }
  ])

  const [alertRemoveSerieClass, setAlertRemoveSerieClass] = useState<{
    isActive: boolean
    id: number
    name: string
  }>({
    id: 0,
    isActive: false,
    name: ''
  })

  const [modalAddFinancialMoviment, setModalAddFinancialMoviment] =
    useState(false)

  const [alertRemoveFinancialMoviment, setAlertRemoveFinancialMoviment] =
    useState<{ isActive: boolean; id: number }>({
      isActive: false,
      id: 0
    })

  const [modalInvoiceData, setModalInvoiceData] = useState<IInvoiceData | null>(
    null
  )

  const [idParentCreate, setIdParentCreate] = useState<number>()
  const [modalTypeSerieClassOpen, setModalTypeSerieClassOpen] =
    useState<TModalType>('closed')
  const [currentSerieClassUpdate, setCurrentSerieClassUpdate] =
    useState<ISeriesClass>()
  const refModalClassSerie = useRef(null)
  const handleClickOnOpenModalCreateSerieClass = (id: number) => {
    setIdParentCreate(id)
    setModalTypeSerieClassOpen('create')
  }

  const handleClickOnCloseSerieClass = () => {
    setModalTypeSerieClassOpen('closed')
  }
  const handlerOnClickButtonEditInCurrentRowSerieClass = (
    currentValue: ISeriesClass
  ) => {
    const { id, is_active, name, school_period, school_year } = currentValue
    setCurrentSerieClassUpdate({
      id,
      is_active,
      name,
      school_period,
      school_year,
      institution_id: institution?.id
    })
    setModalTypeSerieClassOpen('update')
  }

  const handlerOnClickButtonRemoveInCurrentRowSerieClass = ({
    id,
    name
  }: ISeriesClass) => {
    setAlertRemoveSerieClass({
      id,
      name: `${name}`,
      isActive: true
    })
  }

  const getInstitution = useCallback(async () => {
    activeLoading()
    try {
      const response = await api.get<IInstitutionData>(apiList(id))
      const { data } = response
      setInstitution(data)
      disableLoading()
    } catch (err) {
      const [, baseUrl, path] = location.pathname.split('/')
      disableLoading()
      addToast({
        type: 'error',
        title: 'Error ao carregar a instituição',
        description:
          'Houve um error ao carregar a instituição, tente novamente mais tarde!'
      })
      if (path.includes('view')) {
        history.push(`/${baseUrl}`)
      } else {
        history.push(`/${baseUrl}/${path}`)
      }
    }
  }, [activeLoading, addToast, disableLoading, history, id, location.pathname])

  useEffect(() => {
    getInstitution()
  }, [getInstitution])

  const handleEmitNFe = useCallback(
    async ({ financial_moviment_id }: { financial_moviment_id: number }) => {
      activeLoading()
      try {
        const response = await api.post(
          `/financial/invoices/emit/${financial_moviment_id}`
        )
        const { emitido, message } = response.data
        if (!emitido) {
          disableLoading()
          addToast({
            type: 'error',
            title: 'Erro ao emitir NF-e',
            description: message || 'Houve um erro ao emitir a NF-e.'
          })
          return
        }
        disableLoading()
        addToast({
          type: 'success',
          title: 'NF-e emitida com sucesso',
          description: message || 'NF-e emitida com sucesso para cliente!'
        })
        getInstitution()
      } catch (error: any) {
        const message = error?.response?.data?.message
        disableLoading()
        addToast({
          type: 'error',
          title: 'Error ao emitir NF-e',
          description:
            message ||
            'Houve um error ao emitir a NF-e, tente novamente mais tarde!'
        })
      }
    },
    [activeLoading, addToast, disableLoading, getInstitution]
  )

  const handlePrintDanfe = useCallback(
    async ({
      financial_moviment_id,
      name
    }: {
      financial_moviment_id: number
      name: string
    }) => {
      activeLoading()
      try {
        const response = await api.get(
          `/financial/invoices/danfe/download/${financial_moviment_id}`,
          { responseType: 'blob' }
        )
        const contentDisposition = response.headers['content-disposition']
        const fileNameMatch = contentDisposition?.match(
          /filename\*?=(?:UTF-8''|")?([^";]+)/i
        )
        const fileName = fileNameMatch?.[1]
          ? decodeURIComponent(fileNameMatch[1].replace(/"/g, '').trim())
          : `danfe-${String(name).replaceAll(' ', '_').toUpperCase()}.pdf`
        const blob =
          response.data instanceof Blob
            ? response.data
            : new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = fileName
        document.body.appendChild(anchor)
        anchor.click()
        anchor.remove()
        window.URL.revokeObjectURL(url)
        disableLoading()
        addToast({
          type: 'success',
          title: 'DANFE baixada com sucesso',
          description: 'O download da DANFE foi iniciado.'
        })
      } catch (error) {
        disableLoading()
        addToast({
          type: 'error',
          title: 'Erro ao baixar DANFE',
          description: 'Houve um erro ao baixar a DANFE, tente novamente!'
        })
      }
    },
    [activeLoading, addToast, disableLoading]
  )

  const handleDownloadXml = useCallback(
    async ({
      financial_moviment_id,
      name
    }: {
      financial_moviment_id: number
      name: string
    }) => {
      activeLoading()
      try {
        const response = await api.get(
          `/financial/invoices/xml/download/${financial_moviment_id}`,
          { responseType: 'blob' }
        )
        const contentDisposition = response.headers['content-disposition']
        const fileNameMatch = contentDisposition?.match(
          /filename\*?=(?:UTF-8''|")?([^";]+)/i
        )
        const fileName = fileNameMatch?.[1]
          ? decodeURIComponent(fileNameMatch[1].replace(/"/g, '').trim())
          : `xml-nfe-${String(name).replaceAll(' ', '_').toUpperCase()}.xml`
        const blob =
          response.data instanceof Blob
            ? response.data
            : new Blob([response.data], { type: 'application/xml' })
        const url = window.URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = fileName
        document.body.appendChild(anchor)
        anchor.click()
        anchor.remove()
        window.URL.revokeObjectURL(url)
        disableLoading()
        addToast({
          type: 'success',
          title: 'XML baixado com sucesso',
          description: 'O download do XML foi iniciado.'
        })
      } catch (error) {
        disableLoading()
        addToast({
          type: 'error',
          title: 'Erro ao baixar XML',
          description: 'Houve um erro ao baixar o XML, tente novamente!'
        })
      }
    },
    [activeLoading, addToast, disableLoading]
  )

  const handleSendDanfeByEmail = useCallback(
    async ({ financial_moviment_id }: { financial_moviment_id: number }) => {
      activeLoading()
      try {
        await api.post(
          `/financial/invoices/danfe/send-institution/${financial_moviment_id}`
        )
        disableLoading()
        addToast({
          type: 'success',
          title: 'DANFE enviada com sucesso',
          description: 'A DANFE foi enviada por e-mail com sucesso.'
        })
      } catch (error) {
        disableLoading()
        addToast({
          type: 'error',
          title: 'Erro ao enviar DANFE',
          description: 'Houve um erro ao enviar a DANFE, tente novamente!'
        })
      }
    },
    [activeLoading, addToast, disableLoading]
  )

  const handleDeleteFinancialMoviment = async (financialMovimentId: number) => {
    activeLoading()
    try {
      await api.delete(
        `/financial/financialMoviments/deleteByInstitution/${financialMovimentId}`
      )
      setAlertRemoveFinancialMoviment({ isActive: false, id: 0 })
      disableLoading()
      addToast({
        type: 'success',
        title: 'Movimentação financeira excluída com sucesso.'
      })
      getInstitution()
    } catch (error: any) {
      setAlertRemoveFinancialMoviment({ isActive: false, id: 0 })
      disableLoading()
      const message = error?.response?.data?.message
      addToast({
        type: 'error',
        title: 'Erro ao excluir movimentação financeira',
        description:
          message ||
          'Houve um erro ao excluir a movimentação financeira, tente novamente mais tarde!'
      })
    }
  }

  const handlerClickButtonCancellAlert = () => {
    setIsActiveAlert({
      id: 0,
      isActive: false,
      name: ''
    })
  }

  const handlerClickButtonConfirmAlert = async (id: string) => {
    try {
      await api.delete(apiDelete(id))
      setIsActiveAlert({
        id: 0,
        isActive: false,
        name: ''
      })
      addToast({
        type: 'success',
        title: 'Instituição removida com sucesso.'
      })
    } catch (err) {
      setIsActiveAlert({
        id: 0,
        isActive: false,
        name: ''
      })
      addToast({
        type: 'error',
        title:
          'Não foi possível remover a instituição, pois ela está registrada num contrato.'
      })
    }
  }

  const handlerClickButtonCancellAlertSerieClass = () => {
    setAlertRemoveSerieClass({
      id: 0,
      isActive: false,
      name: ''
    })
  }

  const handlerClickButtonConfirmAlertSerieClass = async (
    serieClassId: string
  ) => {
    try {
      await api.delete(apiDeleteSerieClass(serieClassId))
      setAlertRemoveSerieClass({
        id: 0,
        isActive: false,
        name: ''
      })
      setInstitution(old => {
        const newInstitution = { ...old }
        newInstitution.series_classes = old.series_classes.filter(
          e => e.id !== +serieClassId
        )
        return newInstitution
      })
      addToast({
        type: 'success',
        title: 'Plano de frequência removido com sucesso.'
      })
    } catch (err) {
      setAlertRemoveSerieClass({
        id: 0,
        isActive: false,
        name: ''
      })
      addToast({
        type: 'error',
        title:
          'Não foi possível remover a série, pois ele está registrada num estudante.'
      })
    }
  }

  const [alertRemoveParent, setAlertRemoveParent] = useState(false)

  const handleOnClickRemoveParent = () => {
    setAlertRemoveParent(true)
  }

  const handlerOnClickButtonConfirmRemoveParent = async (id: number) => {
    try {
      await api.delete(apiDelete(String(id)))
      setAlertRemoveParent(false)
      addToast({
        type: 'success',
        title: 'Instituição removida com sucesso.'
      })
      history.goBack()
    } catch (err: any) {
      setAlertRemoveParent(false)
      if (err.response.status === 403) {
        addToast({
          type: 'error',
          title: err.response.data.message
        })
        return
      }
      addToast({
        type: 'error',
        title:
          'Não é possível remover essa instituição, pois ela está registrada num contrato.'
      })
    }
  }

  const handlerOnClickButtonCancelRemoveParent = () => {
    setAlertRemoveParent(false)
  }

  const [modalAbsence, setModalAbsence] = useState<{
    isActive: boolean
  }>({
    isActive: false
  })

  const onCloseModalAbsence = () => {
    getInstitution()
    setModalAbsence({
      isActive: false
    })
  }

  const onSuccessModalAbsence = () => {
    getInstitution()
    setModalAbsence({
      isActive: false
    })
  }

  return (
    <>
      <Container
        pageTitle={nameActions.read.name}
        breadcrumb={breadcrumbView}
        tools={[
          toolsViewUpdate(String(id)),
          toolsViewDelete(() => {
            handleOnClickRemoveParent()
          }),
          toolsViewCreate(),
          toolsViewList()
        ]}
      >
        <div className="form-body">
          <div className="row mb-5">
            <ViewInfoLabel col={3} description={institution?.id} label="Cód." />
            <ViewInfoLabel
              col={3}
              description={institution?.company_name}
              label="Razão Social"
            />
            <ViewInfoLabel
              col={3}
              description={institution?.company_social_name}
              label="Nome Fantasia"
            />
            <ViewInfoLabel
              col={3}
              description={cnpjMask(institution?.cnpj)}
              label="CNPJ"
            />
          </div>
          <div className="separator my-5" />
          <div className="row mb-5">
            <ViewInfoLabel
              col={3}
              description={institution?.zip_code}
              label="CEP"
            />
            <ViewInfoLabel
              col={3}
              description={institution?.street}
              label="Logradouro"
            />
            <ViewInfoLabel
              col={3}
              description={institution?.number}
              label="Número"
            />
            <ViewInfoLabel
              col={3}
              description={institution?.complement}
              label="Complemento"
            />
          </div>
          <div className="row mb-5">
            <ViewInfoLabel
              col={3}
              description={institution?.district}
              label="Bairro"
            />
            <ViewInfoLabel
              col={3}
              description={`${institution?.city} | ${institution?.state}`}
              label="Cidade"
            />
            <ViewInfoLabel
              col={4}
              descriptionWithLink={
                <div>
                  <p>
                    {institution?.absence_start && institution.absence_end && (
                      <span>
                        {moment(
                          institution.absence_start,
                          'DD/MM/YYYY HH:mm:ss'
                        )
                          .add(3, 'h')
                          .format('DD/MM/YYYY')}
                        -{' '}
                        {moment(institution.absence_end, 'DD/MM/YYYY HH:mm:ss')
                          .add(3, 'h')
                          .format('DD/MM/YYYY')}
                      </span>
                    )}
                    <span
                      className="fa fa-edit mx-2 p-2 cursor-pointer"
                      onClick={() => setModalAbsence({ isActive: true })}
                    ></span>
                  </p>
                </div>
              }
              label="Dias atípicos"
            />
          </div>
          <div className="separator my-5" />
          <div className="row mb-5">
            <ViewInfoLabel
              col={3}
              description={phoneMask(institution?.phone || '')}
              label="Telefone 1"
            />
            <ViewInfoLabel
              col={3}
              description={phoneMask(institution?.phone_2 || '')}
              label="Telefone 2"
            />
            <ViewInfoLabel
              col={3}
              description={institution?.email}
              label="E-mail"
            />
            <ViewInfoLabel
              col={3}
              description={institution?.email_2}
              label="E-mail 2"
            />
          </div>
          <div className="separator my-5" />
          <div className="row mb-5">
            <ViewInfoLabel
              col={3}
              description={institution?.has_comission === true ? 'Sim' : 'Não'}
              label="Comissão"
            />
            <ViewInfoLabel
              col={3}
              description={`${institution?.percentage_comission} %`}
              label="Porcentagem da comissão"
            />
            <ViewInfoLabel
              col={3}
              description={institution?.is_active === true ? 'Sim' : 'Não'}
              label="Ativo"
            />
            <ViewInfoLabel
              col={3}
              description={institution?.created_at}
              label="Cadastrado em"
            />
          </div>
          <div className="separator my-5" />
          <div className="row">
            <ViewInfoLabel
              col={3}
              description={institution?.observation}
              label="Observações"
            />
          </div>
          <div className="row">
            <div className="col-md-12">
              <Tabs>
                <Tab key={0} title="Estudantes">
                  <div className="portlet light">
                    <div className="card-header p-0">
                      <div className="card-title m-0 fw-bolder fs-6 text-gray-800">
                        Listagem
                      </div>
                    </div>
                    <div className="portlet-body form">
                      <DataTable
                        format={{ orderBy: 'name' }}
                        source="commercial/students"
                        entity="Student"
                        onlyView
                        headers={headersStudentQueryApi}
                        searchParameters={searchParams.current}
                        actions={[
                          {
                            name: 'view',
                            title: 'Visualizar',
                            spanIcon: 'fa fa-search',
                            linkTo: student =>
                              `/commercial/students/view/${student.id}`,
                            style: { margin: '0 5px' }
                          }
                        ]}
                      />
                    </div>
                  </div>
                </Tab>

                <Tab key={1} title="Séries/Turmas">
                  <div>
                    <div className="card-header p-0 d-flex - align-items-center">
                      <div className="card-title m-0 fw-bolder fs-6 text-gray-800">
                        Listagem
                      </div>
                      <div className="">
                        <a
                          href="#"
                          onClick={() =>
                            handleClickOnOpenModalCreateSerieClass(Number(id))
                          }
                          style={{ cursor: 'pointer' }}
                        >
                          <span className="fa fa-plus" /> Adicionar
                        </a>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <MenuTable
                        id="kt_datatable"
                        className="table table-striped table-row-bordered gs-3 border table-hover dataTable"
                      >
                        <thead className="border-bottom border-end">
                          <tr>
                            <th>Ano/Turma</th>
                            <th>Turno</th>
                            <th>Nome</th>
                            <th>Ativo</th>
                            <th>Cadastrado em</th>
                            <th className="text-center">Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {institution?.series_classes?.length === 0 && (
                            <tr>
                              <td colSpan={6} className="text-center">
                                Nenhum registro encontrado
                              </td>
                            </tr>
                          )}
                          {institution?.series_classes?.map(serie_class => {
                            return (
                              <MenuTableRow key={serie_class.id}>
                                <td>{serie_class.school_year}</td>
                                <td>{serie_class.school_period}</td>
                                <td>{serie_class.name}</td>
                                <td>
                                  {serie_class.is_active === true
                                    ? 'Sim'
                                    : 'Não'}
                                </td>
                                <td>{serie_class.created_at}</td>
                                <td>
                                  <LinkContainer className="gap-2">
                                    <button
                                      onClick={() =>
                                        handlerOnClickButtonEditInCurrentRowSerieClass(
                                          serie_class
                                        )
                                      }
                                      style={{
                                        border: 'none',
                                        color: '#009EF7',
                                        background: 'none'
                                      }}
                                    >
                                      <span className="fa fa-edit" />
                                    </button>
                                    <button
                                      onClick={() =>
                                        handlerOnClickButtonRemoveInCurrentRowSerieClass(
                                          serie_class
                                        )
                                      }
                                      className="text-decoration-none"
                                      style={{
                                        border: 'none',
                                        color: '#009EF7',
                                        background: 'none'
                                      }}
                                    >
                                      <span className="fa fa-remove" />
                                    </button>
                                  </LinkContainer>
                                </td>
                              </MenuTableRow>
                            )
                          })}
                        </tbody>
                      </MenuTable>
                    </div>
                  </div>
                </Tab>

                <Tab key={2} title="Cardápios">
                  <div className="portlet light">
                    <div className="card-header p-0">
                      <div className="card-title m-0 fw-bolder fs-6 text-gray-800">
                        Listagem
                      </div>
                    </div>
                    <div className="portlet-body form">
                      <DataTable
                        format={{ orderBy: 'id' }}
                        source="commercial/menuFoods"
                        entity="MenuFoodInstitution"
                        onlyView
                        headers={headersMenuQueryApi}
                        searchParameters={searchParams.current}
                        actions={[
                          {
                            name: 'view',
                            title: 'Visualizar',
                            spanIcon: 'fa fa-search',
                            linkTo: menu_institution =>
                              `/commercial/menuFoods/view/${menu_institution.menu_food_id}`,
                            style: { margin: '0 5px' }
                          }
                        ]}
                      />
                    </div>
                  </div>
                </Tab>

                <Tab key={3} title="Movimentações financeiras">
                  <div>
                    <div className="card-header p-0 d-flex - align-items-center">
                      <div className="card-title m-0 fw-bolder fs-6 text-gray-800">
                        Listagem
                      </div>
                      <div>
                        <a
                          href="#"
                          onClick={e => {
                            e.preventDefault()
                            setModalAddFinancialMoviment(true)
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          <span className="fa fa-plus" /> Adicionar
                        </a>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table
                        id="kt_datatable"
                        className="table table-striped table-row-bordered gs-3 border table-hover dataTable"
                      >
                        <thead className="border-bottom border-end">
                          <tr>
                            <th>Data de vencimento</th>
                            <th>Valor</th>
                            <th style={{ textAlign: 'center' }}>Fiscal</th>
                            <th style={{ textAlign: 'center' }}>Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {institution?.financial_moviments?.length === 0 && (
                            <tr>
                              <td colSpan={11} className="text-center">
                                Nenhum registro encontrado
                              </td>
                            </tr>
                          )}
                          {institution?.financial_moviments?.map(fm => {
                            const situation = 'Pago'

                            const invoiceData = !!fm.invoice_data
                            const approvedInvoice = !!fm.approved_invoice_id

                            return (
                              <MenuTableRow key={fm.id}>
                                <td>{fm.due_date?.slice(0, 10)}</td>
                                <td>{currencyMask(fm.value)}</td>
                                <td>
                                  {situation === 'Pago' &&
                                    invoiceData &&
                                    !approvedInvoice && (
                                      <LinkContainer className="gap-2 ">
                                        <div>
                                          <span
                                            title="Emitir NF-e"
                                            style={{
                                              border: 'none',
                                              color: '#009EF7'
                                            }}
                                            onClick={() =>
                                              handleEmitNFe({
                                                financial_moviment_id: fm.id
                                              })
                                            }
                                          >
                                            <FaFileInvoice />
                                          </span>
                                        </div>
                                      </LinkContainer>
                                    )}
                                  {situation === 'Pago' && approvedInvoice && (
                                    <LinkContainer className="gap-2 ">
                                      <div>
                                        <span
                                          title="Imprimir DANFE"
                                          style={{
                                            border: 'none',
                                            color: '#009EF7'
                                          }}
                                          onClick={() =>
                                            handlePrintDanfe({
                                              financial_moviment_id: fm.id,
                                              name:
                                                institution.company_name ||
                                                institution.company_social_name ||
                                                'cliente'
                                            })
                                          }
                                        >
                                          <FaFilePdf />
                                        </span>
                                      </div>
                                      <div>
                                        <span
                                          title="Baixar XML"
                                          style={{
                                            border: 'none',
                                            color: '#009EF7'
                                          }}
                                          onClick={() =>
                                            handleDownloadXml({
                                              financial_moviment_id: fm.id,
                                              name:
                                                institution.company_name ||
                                                institution.company_social_name ||
                                                'cliente'
                                            })
                                          }
                                        >
                                          <FaFileCode />
                                        </span>
                                      </div>
                                      <div>
                                        <span
                                          title="Enviar Danfe por email"
                                          style={{
                                            border: 'none',
                                            color: '#009EF7'
                                          }}
                                          onClick={() =>
                                            handleSendDanfeByEmail({
                                              financial_moviment_id: fm.id
                                            })
                                          }
                                        >
                                          <FaEnvelope />
                                        </span>
                                      </div>
                                    </LinkContainer>
                                  )}
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                  {fm.invoice_data && (
                                    <button
                                      type="button"
                                      className="btn btn-sm"
                                      title="Ver detalhes dos produtos"
                                      onClick={() =>
                                        setModalInvoiceData(fm.invoice_data)
                                      }
                                    >
                                      <span className="fa fa-list" />
                                    </button>
                                  )}
                                  <button
                                    type="button"
                                    className="btn btn-sm ms-1"
                                    title="Excluir movimentação"
                                    style={{ color: 'red' }}
                                    onClick={() =>
                                      setAlertRemoveFinancialMoviment({
                                        isActive: true,
                                        id: fm.id
                                      })
                                    }
                                  >
                                    <span className="fa fa-trash" />
                                  </button>
                                </td>
                              </MenuTableRow>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Tab>

                <Tab title="Histórico" key={4}>
                  <div className="portlet light">
                    <div className="card-header p-0">
                      <div className="card-title m-0 fw-bolder fs-6 text-gray-800">
                        Listagem
                      </div>
                    </div>
                    <div className="portlet-body form">
                      <DataTable
                        entityId={id}
                        format={{ orderBy: '' }}
                        source="auditLogs"
                        entity="AuditLog"
                        searchParameters={searchParametersAuditLog.current}
                      />
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </Container>
      <Modal
        refModal={refModalClassSerie}
        onClickButtonCancel={handleClickOnCloseSerieClass}
        isOpenModal={modalTypeSerieClassOpen !== 'closed'}
        pageTitle={
          modalTypeSerieClassOpen === 'create' ? 'Adicionar' : 'Editar'
        }
        Children={
          <FormSerieClass
            typeForm={
              modalTypeSerieClassOpen === 'create' ? 'create' : 'update'
            }
            isOpenInModal={{
              handleOnClose: handleClickOnCloseSerieClass,
              idParent: Number(idParentCreate)
            }}
            setInstitution={setInstitution}
            institution_id={institution?.id}
            initialValues={
              modalTypeSerieClassOpen === 'update' && {
                ...currentSerieClassUpdate,
                idUpdate: currentSerieClassUpdate?.id
              }
            }
          />
        }
      />
      <Alert
        message={`Tem certeza que deseja excluir o registro ${alert.name} ?`}
        onClickCancelButton={handlerClickButtonCancellAlert}
        onClickConfirmButton={() => {
          handlerClickButtonConfirmAlert(String(alert.id))
        }}
        isActive={alert.isActive}
      />
      <Alert
        message={`Tem certeza que deseja excluir o registro ${institution?.company_social_name} ?`}
        onClickCancelButton={handlerOnClickButtonCancelRemoveParent}
        onClickConfirmButton={() =>
          handlerOnClickButtonConfirmRemoveParent(Number(institution?.id))
        }
        isActive={alertRemoveParent}
      />
      <Alert
        message={`Tem certeza que deseja excluir o registro ${alertRemoveSerieClass.name} ?`}
        onClickCancelButton={handlerClickButtonCancellAlertSerieClass}
        onClickConfirmButton={() => {
          handlerClickButtonConfirmAlertSerieClass(
            String(alertRemoveSerieClass.id)
          )
        }}
        isActive={alertRemoveSerieClass.isActive}
      />
      <Alert
        message="Tem certeza que deseja excluir esta movimentação financeira?"
        onClickCancelButton={() =>
          setAlertRemoveFinancialMoviment({ isActive: false, id: 0 })
        }
        onClickConfirmButton={() =>
          handleDeleteFinancialMoviment(alertRemoveFinancialMoviment.id)
        }
        isActive={alertRemoveFinancialMoviment.isActive}
      />
      <Modal
        isOpenModal={modalAbsence.isActive}
        onClickButtonCancel={onCloseModalAbsence}
        Children={
          <FormAbsencePeriod
            initialValues={institution}
            onSuccessSubmit={onSuccessModalAbsence}
          />
        }
        pageTitle="Dias atípicos"
      />
      <Modal
        isOpenModal={!!modalInvoiceData}
        onClickButtonCancel={() => setModalInvoiceData(null)}
        pageTitle="Detalhamento dos produtos"
        Children={
          <div>
            <table className="table table-striped table-row-bordered gs-3 border">
              <thead>
                <tr>
                  <th>Cód.</th>
                  <th>Produto</th>
                  <th>Preço unit.</th>
                  <th>Qtd.</th>
                  <th>Total</th>
                  <th>Observação</th>
                </tr>
              </thead>
              <tbody>
                {modalInvoiceData?.menu_foods?.map((item, i) => (
                  <tr key={i}>
                    <td>{item.cod}</td>
                    <td>{item.name}</td>
                    <td>{currencyMask(item.price)}</td>
                    <td>{item.quantity}</td>
                    <td>{currencyMask(item.price * item.quantity)}</td>
                    <td>{item.observation || '-'}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={4} className="text-end fw-bold">
                    Total geral:
                  </td>
                  <td className="fw-bold">
                    {currencyMask(
                      modalInvoiceData?.menu_foods?.reduce(
                        (acc, item) => acc + item.price * item.quantity,
                        0
                      ) ?? 0
                    )}
                  </td>
                  <td />
                </tr>
              </tfoot>
            </table>
          </div>
        }
      />
      <Modal
        isOpenModal={!!modalInvoiceData}
        onClickButtonCancel={() => setModalInvoiceData(null)}
        pageTitle="Detalhamento dos produtos"
        Children={
          <div>
            <table className="table table-striped table-row-bordered gs-3 border">
              <thead>
                <tr>
                  <th>Cód.</th>
                  <th>Produto</th>
                  <th>Preço unit.</th>
                  <th>Qtd.</th>
                  <th>Total</th>
                  <th>Observação</th>
                </tr>
              </thead>
              <tbody>
                {modalInvoiceData?.menu_foods?.map((item, i) => (
                  <tr key={i}>
                    <td>{item.cod}</td>
                    <td>{item.name}</td>
                    <td>{currencyMask(item.price)}</td>
                    <td>{item.quantity}</td>
                    <td>{currencyMask(item.price * item.quantity)}</td>
                    <td>{item.observation || '-'}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={4} className="text-end fw-bold">
                    Total geral:
                  </td>
                  <td className="fw-bold">
                    {currencyMask(
                      modalInvoiceData?.menu_foods?.reduce(
                        (acc, item) => acc + item.price * item.quantity,
                        0
                      ) ?? 0
                    )}
                  </td>
                  <td />
                </tr>
              </tfoot>
            </table>
          </div>
        }
      />
      <Modal
        isOpenModal={modalAddFinancialMoviment}
        onClickButtonCancel={() => setModalAddFinancialMoviment(false)}
        pageTitle="Adicionar movimentação financeira"
        Children={
          <FormAddFinancialMoviment
            institution_id={Number(id)}
            isOpenInModal={{
              handleOnClose: () => {
                setModalAddFinancialMoviment(false)
                getInstitution()
              }
            }}
          />
        }
      />
    </>
  )
}

export default InstitutionView
